import React from 'react';

export const SidebarArrowIcon = ({ className = '' }: { className?: string }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 6L8 10L12 6"
      stroke="white"
      strokeWidth="1.336"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
